import React from 'react';

import AuthorizedComponent from './AuthorizedComponent';
import UnauthorizedComponent from './UnauthorizedComponent';

import { useAuthStateContext } from './Authorization';
import AuthStates from './AuthorizationState';

const AuthorizationComponent = (props) => {
    const { authState } = useAuthStateContext();
    const { children } = props;

    const viewStates = {};

    viewStates[AuthStates.SignedIn] = (
        <AuthorizedComponent>
            {children}
        </AuthorizedComponent>
    );

    return viewStates[authState] ? viewStates[authState] : <UnauthorizedComponent />;
};
export default AuthorizationComponent;